import type { TranslationFunctions, Translations } from '$i18n/i18n-types';
import { characterNames } from '$lib/consts.generated';
import type ERAR from '$lib/erar/spec';
import { getSubcategoryName } from '../item/translation';
import type { CharacterImageType } from './consts';

export function getCharacterImagePath(
  characterId: number,
  type: CharacterImageType,
  skinIndex: number,
) {
  if (characterId === 0) {
    return `/images/characters/CharLobby_Random.webp`;
  }

  return `/images/characters/Char${type}_${getCharacterPathName(characterId)}_S${skinIndex
    .toString()
    .padStart(3, '0')}.webp`;
}

export function getCharacterPathName(characterId: number): string {
  let characterName: string = characterNames[characterId];
  // HACK
  switch (characterId) {
    case 63:
      characterName = 'Lyanh';
      break;
    case 65:
      characterName = 'DebiMarlene';
  }

  return characterName;
}

export function getTranslatedCharacterName(LL: TranslationFunctions, id: number): string {
  return LL.er.characters[id.toString() as keyof Translations['er']['characters']]();
}

export function getTranslatedCharacterFullName(LL: TranslationFunctions, id: number): string {
  const storyName =
    LL.er.characterStories.names[
      id.toString() as keyof Translations['er']['characterStories']['names']
    ]();
  return storyName === '' ? getTranslatedCharacterName(LL, id) : storyName;
}
export function getTranslatedCharacterTitle(LL: TranslationFunctions, id: number): string {
  return LL.er.characterStories.titles[
    id.toString() as keyof Translations['er']['characterStories']['titles']
  ]();
}
export function getTranslatedCharacterDescription(LL: TranslationFunctions, id: number): string {
  return LL.er.characterStories.descriptions[
    id.toString() as keyof Translations['er']['characterStories']['descriptions']
  ]().replaceAll('\\n', '<br>');
}

export function getCharacterWeaponName(
  LL: TranslationFunctions,
  idToCharacterWeapon: Map<number, ERAR.Schema.StaticCharacterWeaponList[number]>,
  id: number,
): string {
  const cw = idToCharacterWeapon.get(id);
  if (cw === undefined) {
    return id.toString();
  }
  return `${getSubcategoryName(LL, cw.itemSubcategoryId)} ${getTranslatedCharacterName(
    LL,
    cw.characterId,
  )}`;
}
